import type { DocumentPageListItem } from '@avisoma//shared';

export function doesPageHaveError(page: DocumentPageListItem): boolean {
  return [
    page.status,
    page.processing?.pdfParser?.status,
    page.processing?.metadata?.status,
    page.processing?.embeddings?.status,
    page.processing?.classification?.status,
  ].includes('error');
}

export function doesPageHaveLowClassificationScore(page: DocumentPageListItem): boolean {
  const score = page.processing?.classification?.result?.[0]?.[1];
  return typeof score === 'number' && score < 0.75;
}

export function isPageProcessing(page: DocumentPageListItem): boolean {
  return [
    page.status,
    page.processing?.pdfParser?.status,
    page.processing?.metadata?.status,
    page.processing?.embeddings?.status,
    page.processing?.classification?.status,
    page.processing?.dataExtraction?.status,
  ].some((status) => status === 'processing' || status === 'pending');
}
